
import React, { useState } from "react";
import "./App.css"
import Header from "./Component/Header";
import logo from "./images/aa.jpg"
import {  useNavigate } from "react-router-dom";
import NavBar from "./Component/NavBar";
import { auth } from "./firebase";
import CreateAccount from "./Component/CreateAccount";
import { signInWithEmailAndPassword } from "firebase/auth";
import MYProgressBar from "./Component/Progressbar";

const Login = () => {

const [show,setmodalshow]=useState(false)
const [pbar,startpbar]=useState(false)
const [error,seterror]=useState();
const navigate=useNavigate();

const [user,setuser]=useState();
    const [pass,setpass]=useState();

    const login=async (e)=>{
       startpbar(true)
        e.preventDefault()
        await signInWithEmailAndPassword(auth,user,pass).then(
            (usercredetial)=>{
                console.log(usercredetial.user.displayName)
                if(usercredetial.user.displayName!=null){
                    localStorage.setItem("admin",usercredetial.user.displayName)
                    navigate('/Admin')
                   
                }               
            })
            .catch((error)=>{
                console.log(error)
                //const errorCode = error.code;
                const errorMessage = error.message;
                startpbar(false)
                seterror("Invalid Email id or Password");
                console.log("firebaserror",errorMessage);

            })
    }

    


    return (
        <>

            <Header />
            <NavBar />
            <div class="container py-5 h-100">

                <div class="card rounded-3 text-black">
                    <div class="row g-0">
                        <div class="col-lg-6">
                            <div class="card-body p-md-5 mx-md-4">

                                <div class="text-center">
                                    <img width="240" height="186" src={logo}
                                        alt="logo" />
                                    <h4 class="mt-1 mb-5 pb-1">We are The Modern Team</h4>
                                </div>
                                <form>


                                    <div class="form-outline mb-3">

                                        <label class="form-label"  for="form2Example11">Username</label>
                                        <input type="email" required="true" onChange={e=>{
                                            e.preventDefault()
                                            const {value}=e.target
                                            setuser(value)
                                        }} id="form2Example11" class="form-control"
                                            placeholder="Phone number or email address" />
                                    </div>

                                    <div class="form-outline mb-3">

                                        <label class="form-label" for="form2Example22">Password</label>
                                        <input onChange={e=>{
                                            e.preventDefault()
                                            const {value}=e.target
                                            setpass(value)
                                        }} type="password" required="Please fill" id="form2Example22" class="form-control" />
                                    </div>

                                    <div class="text-center pt-1 mb-5 pb-1">
                                    {
                                           pbar===false?
                                           <button onClick={login} class="btn btn-primary btn-block fa-lg gradient-custom-2 mb-3" type="button">Log
                                            in</button>:
                                            <MYProgressBar 
                                              now="100"
                                              label="Login in your Account Please Wait"
                                            />
                                           
                                        }
                                        <div>{error}</div>
                                        <a class="text-muted" href="#!">Forgot password?</a>
                                    </div>

                                    <div class="d-flex align-items-center justify-content-center pb-4">
                                        <p class="mb-0 me-2">Don't have an account?</p>
                                       
                                        <button name="submit" type="button" onClick={()=>setmodalshow(true)} class="btn btn-outline-danger">Create new</button>
                                    </div>

                                </form>

                            </div>

                        </div>
                        <div class="col-lg-6 d-flex align-items-center">
                            <div class="text-black px-3 py-4 p-md-5 mx-md-4">
                                <div className="col-10 float-left m-5">
                                    <img class="img-fluid" src={logo} alt={logo} width="240" height="186" />
                                </div>
                                <h4 class="mb-4">We are more than just a School</h4>
                                <p class="small mb-0">We are Orgnization where we teach the descipline and CiVilization and Culture of our sociaty
                                The most important day of a person’s education is the first day of school, not Graduation Day.</p>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    show===true ?
                    <CreateAccount 
                       show={show}
                       onHide={()=>setmodalshow(false)}
                    />
                    :<div></div>
                }
            </div>
            

        </>
    );
};
export default Login;
